import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import VisibilityIcon from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/visibility/VisibilityIcon';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./PageOverlayTabsContextMenu.less');
const cx = classnames.bind(styles);

export enum PageOverlayTabsContextMenuIcons
{
    PIN = 'pin',
    UNPIN = 'unpin',
    SHOW = 'show',
    HIDE = 'hide',
    REMOVE = 'remove',
    EMPTY = 'empty',
}

export interface PageOverlayTabsContextMenuIconProps
{
    icon: PageOverlayTabsContextMenuIcons,
}

function getIconElem(icon:PageOverlayTabsContextMenuIcons):JSX.Element | null
{
    if (icon === PageOverlayTabsContextMenuIcons.PIN)
        return <MDIcon
            className={cx('menuItemIcon')}
            name={MDIcons.common.Pin}
            size={MDIconSize.medium16}
        />;

    if (icon === PageOverlayTabsContextMenuIcons.UNPIN)
        return <MDIcon
            className={cx('menuItemIcon')}
            name={MDIcons.common.Unpin}
            size={MDIconSize.medium16}
        />;

    if (icon === PageOverlayTabsContextMenuIcons.SHOW)
        return <VisibilityIcon
            className={cx('menuItemIcon', 'visibilityEye')}
            crossedPartClassName={cx('visibilityEye__Crossed', {displayed: false})}
        />;

    if (icon === PageOverlayTabsContextMenuIcons.HIDE)
        return <VisibilityIcon
            className={cx('menuItemIcon', 'visibilityEye')}
            crossedPartClassName={cx('visibilityEye__Crossed', {displayed: true})}
        />;

    if (icon === PageOverlayTabsContextMenuIcons.REMOVE)
        return <MDIcon
            className={cx('menuItemIcon')}
            name={MDIcons.common.Close}
            size={MDIconSize.medium16}
        />;

    return null;
}

export const PageOverlayTabsContextMenuIcon:React.SFC<PageOverlayTabsContextMenuIconProps> = ({icon}:PageOverlayTabsContextMenuIconProps) =>
{
    return <div className={cx('menuItemIconWrapper')}>
        {getIconElem(icon)}
    </div>;
};
